import TopBar from './Common/TopBar';
import TestSeriesLanding from './Test/Landing';
import Breadcrumbs from './Common/Breadcrumbs';

const AllTestSeries = () => (
  <>
    <TopBar
      breadcrumbs={<Breadcrumbs type={Breadcrumbs.TYPE.ONLY_TEST_SERIES} />}
      title="Test series"
      showTabSwitcher={false}
    />
    <TestSeriesLanding dataAnalytics="testSeries" showAll />
  </>
);

export default AllTestSeries;
